import React, { Component } from "react";
import PropTypes, { func } from "prop-types";
import { connect } from "react-redux";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Calendar, { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import DateTimeField from "components/InputField/DateTimeField";
import UserTypeSelectCalendar from "containers/Calendar/UserTypeSelectCalendar";
import InputField from "components/InputField/InputField";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";
import { Link } from "react-router";
import Icon from "material-ui/Icon";
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import Results from "components/Quiz/Results";
import { findBlocked, formatDay } from "services/bankHolidays";

const labels = {
  webinar_title: "Webinar Title",
  user_id: "",
  accreditation: "",
  providing_speaker: "",
  sponsor: "test sponsor",
  start_date: "2021-07-12 11:02:21",
  end_date: "2021-07-12 12:02:21",
  name: "Name",
  location: "Location",
  expert_type: "Expert type",
  user_types: "User type",
  email: "Your Contact Email",
  phone: "Phone",
  contact_name: "Your Contact Name",
  comment: "Comment",
  pending: "This booking hasn't been yet confirmed",
  approved: "This booking has been confirmed",
};
const localizer = momentLocalizer(moment);

// Blocked ranges for the calendar being rendered; read by the day-cell wrapper,
// which react-big-calendar instantiates itself (no extra props can be passed).
let currentHolidays = [];

const BlockedDateCellWrapper = (props) => {
  const blocked = findBlocked(currentHolidays, props.value);
  if (!blocked) {
    return <div className="calendar-slot">{props.children}</div>;
  }
  return (
    <div
      className="calendar-slot calendar-slot-blocked"
      title={`${blocked.name} (${formatDay(blocked.from)} - ${formatDay(
        blocked.to
      )}): bookings not available`}
    >
      {props.children}
    </div>
  );
};

const blockedDayPropGetter = (date) =>
  findBlocked(currentHolidays, date)
    ? { className: "rbc-day-blocked" }
    : {};

class Event extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
    };
  }

  handleEventClick = (e) => {
    e.stopPropagation();
    const monthRow = e.target.closest("div.rbc-month-row");
    if (monthRow) {
      monthRow.classList.add("z-index-1000");
    }
    this.setState({ isVisible: !this.state.isVisible });
  };

  handleClose = (e) => {
    e.stopPropagation();
    const monthRow = document.querySelector("div.rbc-month-row.z-index-1000");
    if (monthRow) {
      monthRow.classList.remove("z-index-1000");
    }
    this.setState({ isVisible: false });
  };

  render() {
    return (
      <span
        className={this.props.event.booking_type}
        onClick={this.handleEventClick}
      >
        <div>
          {moment(this.props.event.start_date).format("h:mm a")}-
          {moment(this.props.event.end_date).format("h:mm a")}
        </div>
        <div>{this.props.event.title}</div>
        {this.state.isVisible ? (
          <div>
            <div
              className="calendar-event-pop-up-background"
              onClick={this.handleClose}
            ></div>

            <div className="calendar-event-pop-up">
              <div className="data-pop-up">
                <div className="title-data-pop-up">
                  {moment(this.props.event.start_date).format("dddd MMM D")}
                </div>
                <div
                  className="close"
                  style={{
                    padding: 0,
                  }}
                  onClick={this.handleClose}
                ></div>
              </div>
              <div className="line-pop-up"></div>
              <div className="title-booking-pop-up">
                {this.props.event.title}
              </div>
              <div style={{ textAlign: "center" }}>
                {moment(this.props.event.start_date).format("h:mm a")} -{" "}
                {moment(this.props.event.end_date).format("h:mm a")}
              </div>
              <div style={{ textAlign: "center" }}>
                {labels[this.props.event.booking_type]}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </span>
    );
  }
}

function CalendarSponsorForm({
  events = [],
  holidays = [],
  booking = {},
  errors = {},
  is_admin,
  is_sponsor,
  onDateChange,
  onPeriodChange,
  onUserTypeChangeCalendar,
  onFieldChange,
  onBookingExpertsAttributesChange,
  onAddExpert,
  onRemoveElement,
  onAccreditationChange,
  onProvidingSpeakerChange,
  onSubmit,
  onTermsOfServiceChange,
  onTextAreaChange,
  onWebinarSpeakerAgreement,
  speakerAgreement,
  termsOfService,
  onWebinarSearchSpeaker,
  speakerSearch,
}) {
  currentHolidays = holidays || [];
  return (
    <div className="page-content-calendar">
      <div className="title-booking"> BOOK A MEETING</div>
      <div className="booking-information">
        <div className="legend"> Legend</div>
        <div className="block-calendar-info">
          <div className="applied-booking"></div>
          <div className="applied-booking-title"> = Tentative bookings</div>
        </div>
        <div className="block-calendar-info">
          <div className="confirmed-booking"></div>
          <div className="confirmed-booking-title"> = Confirmed Bookings</div>
        </div>
        {currentHolidays.length ? (
          <div className="block-calendar-info">
            <div className="blocked-booking"></div>
            <div className="blocked-booking-title">
              {" "}
              = Not available for booking
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {is_admin ? (
        <div className="calendar_list_button">
          <Link className="button_classic" to="/calendar/pending_booking">
            <i className="material-icons"></i>
            Pending booking
          </Link>
          <Link className="button_classic" to="/calendar/approve_booking">
            <i className="material-icons"></i>
            Approved booking
          </Link>
          <Link className="button_classic" to="/calendar/rejected_booking">
            <i className="material-icons"></i>
            Rejected booking
          </Link>
        </div>
      ) : (
        ""
      )}

      <div className="calendar-content">
        <div className="block-data-choice">
          <Accordion>
            <AccordionItem>
              <p>Click step 1 to begin booking process.</p>
              <AccordionItemTitle>Step 1: Choose audience</AccordionItemTitle>
              <AccordionItemBody>
                <div className="user-choice">
                  <UserTypeSelectCalendar
                    className="col s12"
                    onChange={onUserTypeChangeCalendar}
                    value={booking.user_types}
                    errors={errors.user_types}
                  />
                </div>
              </AccordionItemBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemTitle>Step 2: Select time</AccordionItemTitle>
              <AccordionItemBody>
                <div className="block-select-time">
                  <DateTimeField
                    className="col s12"
                    onChange={onDateChange}
                    value={booking.start_date}
                    label="Start date"
                    field_name="start_date"
                    errors={errors["start_date"]}
                  />
                  <DateTimeField
                    className="col s12"
                    onChange={onDateChange}
                    value={booking.end_date}
                    label="End date"
                    field_name="end_date"
                    errors={errors["end_date"]}
                  />
                </div>
              </AccordionItemBody>
            </AccordionItem>

            <AccordionItem>
              <AccordionItemTitle>Step 3: Meeting title</AccordionItemTitle>
              <AccordionItemBody>
                <div className="add-webinar-booking">
                  <InputField
                    className="coll s12"
                    label={labels["webinar_title"]}
                    field_name="webinar_title"
                    onChange={onFieldChange}
                    errors={errors["webinar_title"]}
                    autoComplete="new-password"
                    value={booking["webinar_title"]}
                  />
                  <p>Add Meeting Type</p>
                  <RadioGroup
                    name="meeting_type"
                    row
                    value={booking["meeting_type"]}
                    onChange={onFieldChange}
                    style={{ justifyContent: "center", gap: 20 }}
                  >
                    <FormControlLabel
                      value="webinar"
                      control={<Radio />}
                      className="hoverWebinar"
                      label="Webinar"
                    />
                    <FormControlLabel
                      value="hybrid"
                      control={<Radio />}
                      className="hoverHybrid"
                      label="Hybrid"
                    />
                  </RadioGroup>
                  {!is_sponsor && (
                    <div>
                      <InputField
                        className="coll s12"
                        label={labels["contact_name"]}
                        field_name="contact_name"
                        onChange={onFieldChange}
                        errors={errors["contact_name"]}
                        autoComplete="new-password"
                        value={booking["contact_name"]}
                      />
                      <InputField
                        className="coll s12"
                        label={labels["email"]}
                        field_name="email"
                        onChange={onFieldChange}
                        errors={errors["email"]}
                        autoComplete="new-password"
                        value={booking["email"]}
                      />
                      <InputField
                        className="coll s12"
                        label={labels["phone"]}
                        field_name="phone"
                        onChange={onFieldChange}
                        errors={errors["phone"]}
                        autoComplete="new-password"
                        value={booking["phone"]}
                      />
                    </div>
                  )}
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                Step 4: Will you be providing speakers for this meeting?
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="block-accreditation">
                  <FormControl className="wimin-webinar">
                    Will you be providing Speakers for this Meeting?
                    <RadioGroup
                      aria-label="booking "
                      label="Accreditation"
                      value={booking.providing_speaker}
                      onChange={onProvidingSpeakerChange}
                      row
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio color="primary" />}
                        label="Yes, I will be providing the speaker(s)"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio color="primary" />}
                        label="No, I would like MedCafe's help sourcing speakers."
                      />
                    </RadioGroup>
                  </FormControl>
                  {booking.providing_speaker ? (
                    <div className="form-details-booking">
                      <div className="calendar-title"> Speakers:</div>
                      {booking.booking_experts_attributes.map(
                        (expert, index) => (
                          <div className="add_expert_row" key={index}>
                            <div className="calendar-speaker">
                              Speaker {index + 1}
                            </div>
                            <Icon
                              onClick={() => onRemoveElement(index)}
                              className="remove_expert"
                            >
                              close
                            </Icon>
                            <InputField
                              className="coll s12"
                              label={labels["name"]}
                              field_name="name"
                              onChange={(e) =>
                                onBookingExpertsAttributesChange(e, index)
                              }
                              errors={errors["name"]}
                              autoComplete="new-password"
                              value={expert["name"]}
                            />
                            <InputField
                              className="coll s12"
                              label={labels["expert_type"]}
                              field_name="expert_type"
                              onChange={(e) =>
                                onBookingExpertsAttributesChange(e, index)
                              }
                              errors={errors["expert_type"]}
                              autoComplete="new-password"
                              value={expert["expert_type"]}
                            />
                            <InputField
                              className="coll s12"
                              label={labels["location"]}
                              field_name="location"
                              onChange={(e) =>
                                onBookingExpertsAttributesChange(e, index)
                              }
                              errors={errors["location"]}
                              autoComplete="new-location"
                              value={expert["location"]}
                            />
                          </div>
                        )
                      )}
                      <a
                        className="add_option"
                        onClick={onAddExpert}
                        href="javascript:void(0)"
                      >
                        Add another speaker
                      </a>
                      <div className="form-details-booking">
                        <p className="booking-confirmation">
                          <input
                            type="checkbox"
                            id="checkbox_in"
                            onClick={(e) =>
                              onWebinarSpeakerAgreement(e.target.value)
                            }
                            value={speakerAgreement}
                          />
                          <label htmlFor="checkbox_in">
                            <div>
                              I will organise the webinar speaker agreement for
                              every speaker and will email to support@medcafe.ie
                              before the meeting.
                            </div>
                          </label>
                        </p>
                        <p className="booking-confirmation-doc">
                          <label htmlFor="checkbox_in">
                            <a
                              download="Webinar_Speaker_Agreement.pdf"
                              href="https://medcafeprod-bucket.fra1.cdn.digitaloceanspaces.com/img/Webinar_Speaker_Agreement.pdf"
                            >
                              Click here to download the Webinar Speaker
                              Agreement
                            </a>
                          </label>
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="texteria_feedback">
                      <textarea
                        placeholder="If you have any comments, suggestions or preferred speakers, please enter them here."
                        onChange={onTextAreaChange}
                        autoComplete="new-location"
                      ></textarea>
                    </div>
                  )}
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>
                Step 5: Would you like this meeting to be accredited for CPD?
              </AccordionItemTitle>
              <AccordionItemBody>
                <div className="block-accreditation">
                  <FormControl className="wimin-webinar">
                    Apply for CPD accreditation?
                    <RadioGroup
                      aria-label="booking "
                      label="Accreditation"
                      value={booking.accreditation}
                      onChange={onAccreditationChange}
                      row
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="No"
                      />
                      <FormControlLabel
                        value={2}
                        control={<Radio color="primary" />}
                        label="Not applicable"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </AccordionItemBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemTitle>Booking Confirmation</AccordionItemTitle>
              <AccordionItemBody>
                <div className="form-details-booking">
                  <p className="booking-confirmation">
                    <input
                      type="checkbox"
                      id="checkbox_in2"
                      onClick={(e) => onWebinarSearchSpeaker(e.target.value)}
                      value={speakerSearch}
                    />
                    <label htmlFor="checkbox_in2">
                      <Link
                        to="/terms_of_service"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        I agree to the terms and conditions
                      </Link>
                    </label>
                  </p>
                </div>

                <button
                  onClick={onSubmit}
                  className="button_classic"
                  type="button"
                  name="button"
                >
                  BOOK WEBINAR
                </button>
              </AccordionItemBody>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="block-calendar">
        <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          onRangeChange={onPeriodChange}
          defaultView="month"
          events={events}
          popupOffset={100}
          startAccessor="start"
          endAccessor="end"
          style={{ minHeight: 570 }}
          components={{
            event: Event,
            dateCellWrapper: BlockedDateCellWrapper,
          }}
          dayPropGetter={blockedDayPropGetter}
          views={["month", "day"]}
          dayMaxEvents={3}
          showMultiDayTimes
          popup
        />
      </div>
    </div>
  );
}

CalendarSponsorForm.defaultProps = {};

CalendarSponsorForm.propTypes = {
  onFieldChange: func,
  onSubmit: func,
};

export default CalendarSponsorForm;



// WEBPACK FOOTER //
// ./src/components/Calendar/Calendar.jsx